import { render, staticRenderFns } from "./GradeCategoryList.vue?vue&type=template&id=6b31e292"
import script from "./GradeCategoryList.vue?vue&type=script&lang=js"
export * from "./GradeCategoryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports